define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./todoActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, TodoActions) {
    "use strict";
    ;
    var Todos = /** @class */ (function () {
        function Todos() {
            this.filterByAny = ko.observable("");
            this.todoActions = new TodoActions();
            this.canExport = ko.observable(UserContext.hasAccess("Admin,ToDo.Export"));
        }
        Todos.prototype.init = function () {
            var self = this;
            $("#page-title").text("Tasks");
            tools.ajaxGet({
                url: "/ToDo/GetTodosLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.lookupLists.GridStructures.TodosStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    self.todoActions.saveCallback = function () {
                        self.mainTable.refresh();
                    };
                    self.todoActions.deleteCallback = function () {
                        self.mainTable.refresh();
                    };
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Todos.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\"><i class=\"fa fa-edit \"></i></a>";
                    if (UserContext.hasAccess("Admin,ToDo.Delete")) {
                        html += "&nbsp;<button class=\"btn btn-sm btn-danger btn-remove\"><i class=\"fa fa-trash-o\"></i></button>";
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ToDo/GetTodos",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#todos-toolbar-template").html()),
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "Todo",
                    title: "Todo",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                gridId: "tblTodos",
                showPagerOnTop: false,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            $("#tblTodos tbody").on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.todoActions.editTodo(dataItem.Id);
                //self.customerActions.removeCustomerConfirm(dataItem.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.todoActions.deleteTodoConfirm(dataItem.Id);
                //self.customerActions.removeCustomerConfirm(dataItem.Id);
                event.preventDefault();
            });
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.mainTable.refresh();
            });
        };
        Todos.prototype.editTodo = function () {
            var self = this;
            self.todoActions.editTodo();
        };
        Todos.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        Todos.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.mainTable.exportTo();
            }
        };
        Todos.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Todo");
                dataLogs.open("Todo logs");
                event.preventDefault();
            }
        };
        Todos.prototype.savePageSettings = function () {
        };
        return Todos;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ToDo/Index")) {
            log.log("Initialize Todos list");
            $(function () {
                (new Todos()).init();
            });
        }
    }, 0);
    return Todos;
});
//# sourceMappingURL=todos.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/todos/todos.js
// module id = 209
// module chunks = 2